import { SearchTableActionRemoveLabelDialog } from '@aibees/elephant/components/search-table-action-remove-label-dialog';
import { useTableActionContext } from '@aibees/elephant/context';
import { LabelType } from '@aibees/elephant/types/label';
import { Box } from '@mui/material';
import { memo } from 'react';
import { QuickActionMenuItem } from '../quick-action-menu-item';
import { SearchTableActionAddLabelDialog } from '../search-table-action-dialog-more/components/search-table-action-add-label-dialog';
import * as Styled from './styles';
import * as SX from './sx';
import type { QuickActionsButtonGroupMoreMenuProps as Props } from './types';

const ANCHOR_ORIGIN = {
  vertical: 'top',
  horizontal: 'right',
} as const;
const TRANSFORM_ORIGIN = {
  vertical: 'top',
  horizontal: 'left',
} as const;

export const QuickActionsButtonGroupLabelsMenu = memo(
  ({ state, anchorEl, handleClose }: Props) => {
    const { labelDialogState, removeLabelDialogState } =
      useTableActionContext();
    const handleCloseMainMenu = () => {
      state.onFalse();
    };

    const handleClickAddLabels = () => {
      labelDialogState.onTrue();
      handleClose?.();
    };

    const handleClickRemoveLabels = () => {
      removeLabelDialogState.onTrue();
      handleClose?.();
    };

    return (
      <Styled.Wrapper
        className="QuickActionsButtonGroupLabelsMenu"
        anchorEl={anchorEl}
        open={state.value}
        onClose={handleCloseMainMenu}
        anchorOrigin={ANCHOR_ORIGIN}
        transformOrigin={TRANSFORM_ORIGIN}
      >
        <Box sx={SX.root}>
          <QuickActionMenuItem
            title="Add/Create Labels"
            onClick={handleClickAddLabels}
          />
          <QuickActionMenuItem
            title="Remove From Labels"
            onClick={handleClickRemoveLabels}
          />
        </Box>

        <SearchTableActionAddLabelDialog />

        <SearchTableActionRemoveLabelDialog
          titleHeader="Remove from Label"
          title="remove Label"
          icon="label-off-outline"
          type={LabelType.LABEL}
        />
      </Styled.Wrapper>
    );
  }
);

QuickActionsButtonGroupLabelsMenu.displayName =
  'QuickActionsButtonGroupLabelsMenu';
